<template>
  <span class="report-problem-root">
    <el-button
      size="mini"
      :type="buttonType"
      :plain="buttonPlain"
      class="report-problem-root__trigger"
      @click="dialogVisible = true"
    >{{ buttonText }}</el-button>

    <el-dialog
      title="Report a problem"
      :visible.sync="dialogVisible"
      width="460px"
      append-to-body
      custom-class="report-problem-dialog"
      :close-on-click-modal="false"
    >
      <p class="report-problem-dialog__desc">
        Tell us what went wrong. A snapshot of the current page state (page,
        error details and device info) is attached automatically so the support
        team can investigate faster.
      </p>
      <el-input
        v-model="problemText"
        type="textarea"
        :rows="4"
        maxlength="1000"
        show-word-limit
        placeholder="Describe the problem..."
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">Cancel</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="submitting"
          @click="submitReport"
        >Send Report</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { sendMessage } from "../../api/index";
import { getUserId, getProjectCode } from "../../utils/store";

export default {
  name: "ReportProblemButton",
  props: {
    buttonText: { type: String, default: "Report problem" },
    buttonType: { type: String, default: "" },
    buttonPlain: { type: Boolean, default: false },
    projectCode: { type: String, default: "" },
    templateName: { type: String, default: "" },
    // Free-form context about where the problem happened (error codes,
    // diagnostics, entry state, etc.). Sent as message details.
    context: { type: Object, default: null },
    // Extra structured info merged into details (exam name, page info...).
    snapshot: { type: Object, default: null },
  },
  data() {
    return {
      dialogVisible: false,
      problemText: "",
      submitting: false,
    };
  },
  methods: {
    submitReport() {
      const content = String(this.problemText || "").trim();
      if (!content) {
        this.$message.error("Please describe the problem first");
        return;
      }

      this.submitting = true;
      const details = {
        ...(this.snapshot || {}),
        ...(this.context || {}),
        user_agent: navigator.userAgent,
        page_url: window.location.href,
        client_time: new Date().toISOString(),
        client_time_ms: Date.now(),
        online: navigator.onLine,
      };
      sendMessage(
        getUserId(),
        "Tech Issue",
        "student",
        content,
        this.projectCode || getProjectCode(),
        this.templateName,
        details
      )
        .then(() => {
          this.$message.success("Your problem has been reported.");
          this.dialogVisible = false;
          this.problemText = "";
          this.$emit("reported");
        })
        .catch(() => {
          this.$message.error("Failed to submit the report. Please try again.");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-problem-root {
  display: inline-flex;
}
</style>

<style lang="scss">
.report-problem-dialog {
  max-width: calc(100vw - 32px);
  border-radius: 10px;
  .el-dialog__header {
    padding: 18px 22px 0;
    .el-dialog__title {
      color: #1b213d;
      font-size: 18px;
      font-weight: 700;
    }
  }
  .el-dialog__body {
    padding: 10px 22px 4px;
  }
  .el-dialog__footer {
    padding: 12px 22px 20px;
  }
}
.report-problem-dialog__desc {
  margin: 0 0 12px;
  color: #596174;
  font-size: 13px;
  line-height: 1.55;
}
</style>
